import type { MembershipSchema } from '@libs/data-access/entities'
import type { MembershipFeaturesPermissionsSchema } from '@libs/data-access/entities/lib/entities/User/Membership/MembershipFeaturesPermissions/MembershipFeaturesPermissions'

import { useFetchCurrentUser } from '../../User/hooks/useFetchCurrentUser/useFetchCurrentUser'
import type { UserMeSchema } from '../../User/types/UserMe.schema'

export const getCurrentMembership = (
  currentUser: UserMeSchema
): MembershipSchema | undefined => {
  return currentUser?.current_membership
}

export const useCurrentMembershipPermissions = ():
  | MembershipFeaturesPermissionsSchema
  | undefined => {
  const { data } = useFetchCurrentUser({})

  return data ? getCurrentMembership(data)?.features_permissions : undefined
}
